// import config
import i18n from 'config/i18n';

// import utils
import { getLocale } from 'utils/date';
import * as yup from 'yup';

const t = i18n.getFixedT(getLocale(), 'common');

const emailValidation = yup
  .string()
  .test('is-valid', t('invalidEmailAddress'), (value) => {
    if (!value) {
      return true;
    }
    const emailSchema = yup.string().email();
    for (const email of value.split(';')) {
      if (!emailSchema.isValidSync(email.trim())) {
        return false;
      }
    }
    return true;
  });

export const schema = yup.object({
  brId: yup.number(),
  code: yup.string().default(''),
  name: yup.string(),
  nameShort: yup.string(),
  brTypeSvc: yup.string(),
  brType: yup.string(),

  validFrom: yup.date(),
  validTo: yup.date(),

  budgetKeeper: yup.string(),
  manager: yup.string(),
  comEmail: emailValidation,
  comEmailCc: emailValidation,
  privilegedEmailAddress: emailValidation,
  comPhone: yup.string(),
  comSms: yup.string(),
  comTelefax: yup.string(),
  issues: yup.string(),

  adrResStreet: yup.string(),
  adrResPostalCode: yup.string(),
  adrResCity: yup.string(),
  adrResCountryCode: yup.string(),
  brCountry: yup.string(),

  requestPool: yup.string(),
  employeePool: yup.string(),
  remarks: yup.string(),
  agenciesRemarks: yup.string(),

  isKids: yup.bool(),
  wcaDescription: yup.string()
});
